var _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV');


var DocTextNote = require('../document/noteTypes/text'),
    DocHTMLNote = require('../document/noteTypes/html'),
    FlashNote = require('../document/noteTypes/flash'),
    ActivityNote = require('../document/noteTypes/activity');


var PgTxtNote = require('../page/noteTypes/text'),
    KeyedTxtNote = require('../page/noteTypes/keyedTextNote'),
    HighlightNt = require('../page/noteTypes/drawable/coordinate/highlight'),
    RedactionNt = require('../page/noteTypes/drawable/coordinate/redaction/redaction'),
    FddGraphicNt = require('../page/noteTypes/fddGraphicNote'),
    SvgGraphicNt = require('../page/noteTypes/drawable/svg/graphic'),
    Signature = require('../page/noteTypes/drawable/svg/signature'),
    GraphicStamp = require('../page/noteTypes/drawable/graphicStamp/graphicStamp'),
    StrikeThrough = require('../page/noteTypes/drawable/coordinate/strikeThrough'),
    FullPageRedaction = require('../page/noteTypes/drawable/coordinate/redaction/fullPageRedaction/model'),
    TextStamp = require('../page/noteTypes/drawable/svg/textStamp/model');


/*
  FDD orange Java Note Type Enum X Viewer JS Note Model Constructor
*/

var DOC_XREF = {
    TEXT_NOTE: DocTextNote,
    HTML_NOTE: DocHTMLNote, //(normalized to text -- can import but can't create) */
    FLASH_NOTE: FlashNote,
    ACTIVITY_NOTE: ActivityNote
};

var PG_XREF = {
    TEXT: PgTxtNote, /* ENUM IS TEXT -- makes easier so doesn't overlap with TEXT_NOTE */
    KEYED_TEXT_NOTE: KeyedTxtNote, //like TEXT notes; always display; these are created instead of regular text notes in auto utr file cabinets
    HIGHLIGHT_NOTE: HighlightNt,
    REDACTION_NOTE: RedactionNt,
    FLOATING_REDACTION_NOTE: RedactionNt,
    SVG_SIGNATURE: Signature,
    SVG_GRAPHIC_NOTE: SvgGraphicNt, // this is the new type for graphic notes created in the Doc Viewer
    GRAPHIC_NOTE: FddGraphicNt, //these are not the legacy FDD graphic notes
    GRAPHIC_STAMP: GraphicStamp,
    STRIKE_THROUGH: StrikeThrough,
    FULL_PAGE_REDACTION: FullPageRedaction,
    GRAPHIC_TEXT_STAMP: TextStamp
};



/**
 *
 * Need to return the constructor for the collection to add post parse/fetch.
 */
module.exports = {

    factory: function( noteType, isDocumentNote ) {
        return (isDocumentNote ? DOC_XREF : PG_XREF)[noteType];
    },

    /**
     * Need these, otherwise will error on getting corresponding note types -- never import these.
     * Called on parse on page and document note collections.
     * DVBC-1791: server is no longer return UTR page notes ( they're already filtered out )
     */
    noteTypesToInclude: function( type ) {

        var XREF = type === 'document' ? DOC_XREF : PG_XREF;
        return _.keys(XREF);

    },

    /**
     * noteType X Constructor -- which contains the properties
     * type: 'document' or 'page*
     * Use this as central fn get get any 'creatable note types' ( it will rid FLOATING_REDACTION_NOTE )
     */
    creatableNotes: function( type ) {

        var isDocument = type === 'document',
            XREF = isDocument ? DOC_XREF : PG_XREF,
            hash = {};

        for (var k in XREF) {

            if ( !XREF[k].prototype.notCreatable )
                hash[k] = XREF[k];

        }

        // Don't show 2 menu items for Floating and Non-Floating Redaction Modes (quick fix) -- they both share the same model
        // ( Maybe utilizing something like noteTypeGroup for this purpose )
        !isDocument && delete hash['FLOATING_REDACTION_NOTE' ];

        return hash;
    },

    /* Only returning the types/keys */
    creatableDrawableNoteTypes: function() {

        var creatablePgNotes = this.creatableNotes( 'page '); // ( call central fn )
        var noteTypes = [];

        for ( var noteType in creatablePgNotes ) {

            if (  creatablePgNotes[noteType].prototype.isDrawable() ) {
                noteTypes.push( noteType );
            }
        }

        return noteTypes;

    },

    //
    //
    /**
     * Here we want a hash -- not the keys.
     * supportsFindAndRedact: only on the drawableNoteType prototypes
     * ( these are creatable by nature )
     */
    getNoteTypesThatSupportFindAndRedact: function() {

        var noteTypes = {};

        var creatablePgNotes = this.creatableNotes( 'page '); // ( call central fn )

        for ( var noteType in creatablePgNotes ) {

            if (  creatablePgNotes[noteType].prototype.isDrawable() && creatablePgNotes[noteType].prototype.supportsFindAndRedact() ) {
                noteTypes[noteType] = creatablePgNotes[noteType];
            }
        }

        return noteTypes;

    }


};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/factory/factory.js
 ** module id = 275
 ** module chunks = 0
 **/